"use client";
import { createCustomTheme, ThemeColors } from "@/themes/shared/themeFactory";

const lightColors: ThemeColors = {
  primary: "#ff734a",
  primaryFg: "#ffffff",
  background: "#ffffff",
  foreground: "#262626",
  secondary: "#F4EBE8",
  secondaryFg: "#4c443f",
  accent: "#ffe2d5",
  card: "#ffffff",
  cardFg: "#262626",
  mutedBg: "#f5f5f5",
  mutedFg: "#4c443f",
  border: "#e5e7eb",
  input: "#e5e7eb",
  destructive: "#ef4444",
  destructiveBg: "#ef44441a",
  destructiveFg: "#ffffff",
  error: "#ef4444",
  errorBg: "#ef44441a",
  errorFg: "#7f1d1d",
  info: "#2c93d6",
  infoBg: "#2c93d61a",
  infoFg: "#014361",
  success: "#5ca75f",
  successBg: "#5ca75f1a",
  successFg: "#1e4620",
  warning: "#ffd900",
  warningBg: "#ffd9001a",
  warningFg: "#7a4f01",
  linkFg: "#2c93d6",
  linkHoverFg: "#014361",
  sidebarBg: "#f9fafb",
  sidebarFg: "#262626",
  dataPlaneSidebarBg: "#eaecef",
  appBarBg: "#f9fafb",
  appBarFg: "#262626",
  tabsBg: "#f5f5f5",
  tabsFg: "#262626",
  tabsInactiveFg: "#4c443f",
};

const theme = createCustomTheme("light", lightColors);

export default theme;
